import { render } from "./EMarket.vue?vue&type=template&id=2246db68"
import script from "./EMarket.vue?vue&type=script&lang=js"
export * from "./EMarket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__